import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { ResourceModule, ServiceModule } from "../../common/const";
import CommonCard from "../../common/components/CommonCard";
import theme from "../../theme";
import { useNavigate } from "react-router-dom";

const Modules = ({
    isService
}) => {
    const navigate = useNavigate();
    return (
        isService ? (
            <Box sx={{ ml: '35px', mr: '40px', background: 'white', mt: 8, mb: 8, borderRadius: 2, p: 2}}>
                <Grid container spacing={2}>
                    {ServiceModule.map((a, index) => (
                        <Grid item md={1.7} key={index} sx={{ cursor: 'pointer'}} onClick={() => navigate(a.link)}>
                            <CommonCard
                                marginTop="0px"
                                borderRadius={2}
                                height="150px"
                                content={
                                    <Box display="flex" flexDirection="column" gap={1} alignItems="center">
                                        <img src={a.images} alt="img" height="50px" width="50px" />
                                        <Typography color={theme.palette.secondary.main} fontWeight={600} textAlign="center" fontSize={18}>{a.title}</Typography>
                                    </Box>
                                }
                                border={`1px solid #7A869126`}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        ) : (
            <Box sx={{ ml: '35px', mr: '40px', background: 'white', mt: 8, mb: 8, borderRadius: 2, p: 2}}>
                <Grid container spacing={2}>
                    {ResourceModule.map((a, index) => (
                        <Grid item md={3} key={index} sx={{ cursor: 'pointer'}} onClick={() => navigate(a.link)}>
                            <CommonCard
                                marginTop="0px"
                                borderRadius={2}
                                content={
                                    <Box display="flex" flexDirection="column" gap={1} alignItems="center">
                                        <img src={a.images} alt="img" height="50px" width="50px" />
                                        <Typography color={theme.palette.secondary.main} fontWeight={600} textAlign="center" fontSize={19}>{a.title}</Typography>
                                    </Box>
                                }
                                border={`1px solid #7A869126`}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        )
    )
};

export default Modules;